import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import get from 'lodash.get';
import { isPreview, getTrackingObj, getNoteByDevice } from './messageHelpers';
import style from './MessageBanner-style.scss';
import classnames from 'classnames';

const MessageBannerItem = props => {
    const { messageItem, isMultiLine } = props;
    const { message, cta } = get(getNoteByDevice(messageItem), 'content', {});

    const _trackCtaClick = () => {
        if (!isPreview()) {
            trackEvent(
                getTrackingObj({
                    messageItem,
                    action: 'banner cta clicked',
                })
            );
        }
    };

    const wrapperClasses = classnames(style.itemWrapper, {
        [style.isSingleLine]: !isMultiLine,
        [style.isMultiLine]: isMultiLine,
    });

    return (
        <div className={wrapperClasses}>
            {message}{' '}
            {cta && (
                <a
                    className={style.ctaLink}
                    href={cta.url}
                    onClick={_trackCtaClick}
                    rel="noopener"
                    target="_blank"
                >
                    {cta.text}
                </a>
            )}
        </div>
    );
};

MessageBannerItem.defaultProps = {
    isMultiLine: false,
};

MessageBannerItem.propTypes = {
    isMultiLine: PropTypes.bool.isRequired,
    messageItem: PropTypes.object.isRequired,
};

export default MessageBannerItem;
